import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { IconContainer } from "../IconContainer.mjs";
import { IconPrintSvg } from "./IconPrintSvg.mjs";
const IconPrint = (props) => /* @__PURE__ */ jsx(IconContainer, { ...props, children: (svgProps) => /* @__PURE__ */ jsx(Box, { component: IconPrintSvg, ...svgProps }) });
export {
  IconPrint
};
